import theme from 'BlockList/styles/theme.module.css';
import type { ReasonKey, SourceKey } from 'BlockList/types';

export const DEFAULT_PAGE_SIZE = 10;

export const ATTRIBUTE_TYPES = {
  email: { label: 'Email' },
  email_domain: { label: 'Email Domain' },
  phone_number: { label: 'Phone Number' },
  vin: { label: 'VIN' },
  drivers_license: { label: "Driver's License" },
  name_dob: { label: 'Name / DOB' },
} as const;

export const REASONS = {
  fraud: { label: 'Fraud' },
  non_payment: { label: 'Non-Payment' },
  material_misrepresentation: { label: 'Material Misrep' },
  claims_history: { label: 'Claims History' },
  legal_compliance: { label: 'Legal Compliance' },
  other: { label: 'Other' },
} as const;

// Pill style maps — `className` resolves to a CSS module class from
// theme.module.css that binds the right Atlas color tokens. PillCell
// applies this className alongside its own structural `.pill` class.
export const REASON_TOKENS: Record<
  ReasonKey,
  { className: string; label: string }
> = {
  fraud: { className: theme.pillFraud, label: 'Fraud' },
  non_payment: { className: theme.pillNonPayment, label: 'Non-Payment' },
  material_misrepresentation: {
    className: theme.pillMaterialMisrepresentation,
    label: 'Material Misrep',
  },
  claims_history: {
    className: theme.pillClaimsHistory,
    label: 'Claims History',
  },
  legal_compliance: {
    className: theme.pillLegalCompliance,
    label: 'Legal Compliance',
  },
  other: { className: theme.pillOther, label: 'Other' },
};

export const REASON_RADIO_OPTIONS: Array<{ value: ReasonKey; label: string }> =
  (Object.keys(REASONS) as ReasonKey[]).map((key) => ({
    value: key,
    label: REASONS[key].label,
  }));

export const SOURCE_TOKENS: Record<
  SourceKey,
  { className: string; label: string }
> = {
  policy_page: { className: theme.pillPolicyPage, label: 'Core' },
  manual: { className: theme.pillManual, label: 'Manual' },
  tmx_import: { className: theme.pillTmxImport, label: 'TMX' },
};
